import { useForm } from "react-hook-form";
import { styled } from "@mui/material";
import CustomTextField from "../../../../ui/components/Form/TextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import MaskedInput from "react-text-mask";
import { useSignUpUser } from "../../api/signUpUser";
import { createNotification } from "../../../../shared/store/notifications";
import { useSignUpParams } from "../../api/getSignUpParams";

const MaskedCPFInput = (props) => {
  const { ref, ...other } = props;
  let mask = null;
  mask = [
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
  ];
  return (
    <MaskedInput
      {...other}
      ref={ref}
      mask={mask}
      placeholderChar={"\u2000"}
      guide
    />
  );
};

const SignUpSchema = yup.object().shape({
  registrationFieldName: yup.string(),
  documentNumber: yup.string().when("registrationFieldName", {
    is: "documentNumber",
    then: () => yup.string().required("Campo obrigatório"),
  }),
  email: yup
    .string()
    .email("Email inválido")
    .when("registrationFieldName", {
      is: "email",
      then: () =>
        yup.string().email("Email inválido").required("Campo obrigatório"),
    }),
});

const StyledForm = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
}));

const getLabel = (registrationFieldName) => {
  switch (registrationFieldName) {
    case "documentNumber":
      return "CPF";
    case "email":
      return "Email";
    default:
      return registrationFieldName;
  }
};

const getInputProps = (registrationFieldName) => {
  switch (registrationFieldName) {
    case "documentNumber":
      return {
        inputComponent: MaskedCPFInput,
      };

    default:
      return {};
  }
};

export default function VerifyRegistration({
  onAlreadyRegistered = () => {},
  onNotRegistered = () => {},
  submitButtonRef = null,
}) {
  const signUpParams = useSignUpParams();
  const registrationFieldName =
    signUpParams.data?.signUpVerificationField || "email";
  const defaultValues = {
    registrationFieldName,
    documentNumber: "",
    email: "",
  };
  const formMethods = useForm({
    defaultValues,
    resolver: yupResolver(SignUpSchema),
  });
  const signUp = useSignUpUser();

  const { handleSubmit } = formMethods;

  const onSubmit = (values) => {
    const requestData = values;
    switch (values.registrationFieldName) {
      case "documentNumber":
        requestData.documentNumber = values.documentNumber
          .replaceAll(".", "")
          .replaceAll("-", "");
        break;
      default:
    }
    signUp.mutate(
      {
        addressComplement: "",
        addressDescription: "",
        city: "",
        email: "",
        name: "",
        neighborhood: "",
        number: "",
        postalCode: "",
        state: "",
        ...requestData,
        config: { suppressNotification: true },
      },
      {
        onSuccess: (data, _var) => {
          if (data.message === "User Already Exists") {
            onAlreadyRegistered(data, _var);
          } else {
            createNotification({ type: "error", message: "Erro" });
          }
        },
        onError: (error, variables) => {
          if (error.data.message === "Fill all mandatory data") {
            onNotRegistered(variables);
          } else {
            createNotification({ type: "error", message: error.data.message });
          }
        },
      }
    );
  };

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      <CustomTextField
        formMethods={formMethods}
        fieldName={registrationFieldName}
        labelText={getLabel(registrationFieldName)}
        InputProps={getInputProps(registrationFieldName)}
        InputLabelProps={{ shrink: true }}
      />

      <button type="submit" ref={submitButtonRef} hidden />
    </StyledForm>
  );
}
